import { gql } from '@apollo/client';

export const fetchInvoicesForShipToParty = gql`
  query fetchInvoicesForShipToParty($id: ID!, $searchOptions: ConnectionSearchOptions, $filterOptions: [FilterOption]) {
    invoiceGroupsForShipToPartyId(id: $id) {
      id
      shipToPartyBillingGroupIds
      invoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          status
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          creditCardMaskedNumber
          dueDate
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          purchaseOrderNumber
          pdfLink
          refunds {
            id
            type
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          dunningStatus {
            errorCode
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
